import { type NodeUser, createNodeUser } from 'models';
import { useQuery } from 'query';
import { getNodeUser } from '../services';
import { getProfileNodeQueryKey } from './keys';

export const useProfileNodeQuery = (options: { gcTime?: number; staleTime?: number; throwOnError?: boolean }) =>
  useQuery<NodeUser>({
    async queryFn() {
      const { data } = await getNodeUser();

      return createNodeUser(data);
    },
    queryKey: getProfileNodeQueryKey(),
    refetchInterval: 15 * 60 * 1000,
    staleTime: 15 * 60 * 1000,
    ...options,
  });
